import { render, staticRenderFns } from "./ProfileImageUploader.vue?vue&type=template&id=746bf2b5"
import script from "./ProfileImageUploader.vue?vue&type=script&lang=js"
export * from "./ProfileImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports